import {useState} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import Snackbar from "../../snackbar/Snackbar";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";
import userGroupApiClient from "../../../../../common/apis/usergroup/UserGroupApiClient";
import {UserGroupsTranslationKey} from "../UserGroupsTranslationKey";
import {invalidateFindAllUserGroupPermissionsQueryCache} from "../UserGroupQuery";

export interface UserGroupPermissionDeleteDialogProps {
    open: boolean;
    groupId: string;
    collectionCode: string;
    onClose: () => void;
}

export default function UserGroupPermissionDeleteDialog(props: Readonly<UserGroupPermissionDeleteDialogProps>) {
    const {open, groupId, collectionCode, onClose} = props;

    const queryClient = useQueryClient();
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    function deletePermission() {
        setDeleteInProgress(true);
        userGroupApiClient.deletePermission(groupId, collectionCode)
            .then(() => {
                invalidateFindAllUserGroupPermissionsQueryCache(groupId, queryClient);
                onClose();
                Snackbar.success(t(CommonTranslationKey.DATA_DELETED_SUCCESSFULLY));
            })
            .catch((err) => {
                Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), err);
            })
            .finally(() => setDeleteInProgress(false));
    }

    return (
            <DeleteConfirmationDialog
                    open={open}
                    title={t(UserGroupsTranslationKey.DELETE_PERMISSION_QUESTION_MARK)}
                    message={t(UserGroupsTranslationKey.PERMISSION_WILL_BE_DELETED)}
                    deleteDisabled={deleteInProgress}
                    onDelete={deletePermission}
                    onDismiss={onClose}/>
    );
}
